import { DateTime } from "luxon";

import { UsagePaymentType } from "lib/types/graphQLEnums";

/** What every Usage page card is filtered by. Each query sends them as they are and keys on them. */
export type UsageFilters = {
  /** How many UTC days the window covers, ending with today. */
  days: number;
  teamId?: string;
  paymentType?: UsagePaymentType;
};

export type UsageWindow = {
  /** Today's UTC date, e.g. "2026-10-01". Queries key on it so a cached window can't outlive it. */
  today: string;
  /** The window's first UTC day. */
  start: DateTime;
  /** Whether the window reaches back before the UTC day `isoDate`, e.g. "2026-10-01". */
  startsBefore: (isoDate: string) => boolean;
};

/**
 * The last `days` UTC days, today included, as every Usage page query counts them. UTC throughout
 * to match the server's day boundaries.
 */
export function usageWindow(days: number): UsageWindow {
  const today = DateTime.utc().startOf("day");
  const start = today.minus({ days: days - 1 });
  const startDate = start.toISODate() ?? "";

  return {
    today: today.toISODate() ?? "",
    start,
    startsBefore: (isoDate) => startDate < isoDate,
  };
}
